<app-header></app-header>
<div class="responsive">
    <div class="container-fluid">



        <div class="row">
            <div class="col-md-3">
                <app-sidebar></app-sidebar>
            </div>
            <div class="col-md-6">
                <div class="row margin-b">
                    <div class="col-md-12">

                        <app-sub-header title="Our Network"></app-sub-header>
                        <div class="row margin-b">
                            <div class="col-md-12">

                                <div style="text-align: end;">
                                    <button routerLink="blocked-users" class="color btn main-backgroundcolor"><i
                                            class="fas fa-ban cursor color"></i> Blocked Users</button>
                                </div>
                            </div>
                        </div>
                        <div class="display margin-b border-r" style="padding: 0 25px;">
                            <div class="header cursor " [ngClass]="{'active':activeTab === 'affilations'}"
                                (click)="getScrollTo('affilations','parent','')" id="affilations">Affilations
                            </div>
                            <div class="header cursor " [ngClass]="{'active':activeTab === 'followers'}"
                                (click)="getScrollTo('followers','parent','')" id="followers">Followers
                            </div>

                        </div>


                        <div *ngIf="activeTab == 'affilations'" class="display">
                            <div class="header cursor" [ngClass]="{'active':activeTab2 === 'Individuals'}"
                                (click)="getScrollTo('Individuals','child','user')" id="user">Individuals
                            </div>
                            <div class="header cursor" [ngClass]="{'active':activeTab2 === 'Merchants'}"
                                (click)="getScrollTo('Merchants','child','merchant')" id="merchant">Merchants
                            </div>
                            <div class="header cursor" [ngClass]="{'active':activeTab2 === 'Ministries'}"
                                (click)="getScrollTo('Ministries','child','community')" id="community">Our Ministries
                            </div>
                            <div class="header cursor " [ngClass]="{'active':activeTab2 === 'partners'}"
                                (click)="getScrollTo('partners','child','partners')" id="partners">Partners
                            </div>
                        </div>
                    </div>
                </div>



                <div class="row">
                    <div class="col-md-12 col-xs-12">
                        <app-no-results-found *ngIf="objArr?.length == 0 && loading" [title]='activeTab2'>
                        </app-no-results-found>


                        <div *ngIf="!loading">
                            <div *ngFor="let props of arr">
                                <app-card-skelton></app-card-skelton>
                            </div>
                        </div>
                        <div class="col-md-12" *ngIf="loading">
                            <div *ngFor="let props of (objArr | paginate
            : {
                itemsPerPage: pageSize,
                currentPage: pageNo,
                totalItems: totalItems
              })">

                                <app-alert-card size=2 [showtext]=true [data]="props" title="Claim" [others]="false"
                                    [sideButton]="true" [route]="route" key="" (getBlock)="getBlock($event)"
                                    (addStaff)="addStaff($event)"></app-alert-card>

                            </div>
                        </div>
                        <div *ngIf="arrList?.length == pageSize && activeTab == 'affilations'" class="col-md-12"
                            style="text-align: center;">
                            <pagination-controls class="col s12 col-md-offset-3 my-pagination"
                                *ngIf="objArr?.length > 0 " (pageChange)="page = affliatedUser($event)"
                                directionLinks="true" autoHide="false" responsive="true" previousLabel="Previous"
                                nextLabel="Next" screenReaderPaginationLabel="Pagination" screenReaderPageLabel="page"
                                screenReaderCurrentLabel="You're on page">
                            </pagination-controls>
                        </div>

                        <div *ngIf=" followersList?.length == pageSize && activeTab == 'followers'" class="col-md-12"
                            style="text-align: center;">
                            <pagination-controls class="col s12 col-md-offset-3 my-pagination"
                                *ngIf="objArr?.length > 0 " (pageChange)="page = followerList($event)"
                                directionLinks="true" autoHide="false" responsive="true" previousLabel="Previous"
                                nextLabel="Next" screenReaderPaginationLabel="Pagination" screenReaderPageLabel="page"
                                screenReaderCurrentLabel="You're on page">
                            </pagination-controls>
                        </div>



                    </div>
                </div>


            </div>
            <div class="col-md-3">
                <app-events [showheader]=true></app-events>

            </div>
        </div>
    </div>
</div>
